import {FlowController} from "./FlowController";
import {Messages} from "../../Messages";
import {startNewsletterFlow} from "./startFlow";

export class NewsletterFlowController extends FlowController {
    actionButtonDefaultAnid = "newsletter-button";

    getHeaderDefaultText() {
        return super.getHeaderDefaultText() || Messages.newsletterText;
    }

    getActionButtonDefaultLabel() {
        return super.getActionButtonDefaultLabel() || Messages.continue;
    }

    onClickAuthenticated() {
        startNewsletterFlow();
    }

    onClickNotAuthenticated() {
        startNewsletterFlow();
    }
}
